<template>
    <div>
        <fusioncharts
            type="hlineargauge"
            width="95%"
            :height="height"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                required: true
            },

            height: {
                type: Number,
                default: 70
            },

            title: {
                type: String,
                required: false
            }
        },

        computed: {
            dataSource() {
                return {
                    chart: {
                        bgColor: "#316DA0",
                        baseFont: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"',
                        baseFontSize: 15,
                        caption: this.title,
                        lowerLimitDisplay: "0%",
                        upperLimitDisplay: "100%",
                        numberSuffix: "%",
                        chartBottomMargin: "0",
                        theme: "fusion",
                        showValue: "0",
                        majorTMNumber: "3",
                        minorTMColor: "#ffffff",
                        majorTMColor: "#ffffff",
                        labelFontColor: "#ffffff",
                        valueFontSize: 16,
                        pointerOnTop: "0",
                        gaugeFillMix: "{light-10},{light-30},{light-20},{dark-5},{color},{light-30},{light-20},{dark-10}",
                        gaugeFillRatio: "",
                    },
                    colorRange: {
                        color: [
                            {
                                minValue: "0",
                                maxValue: "25"
                            },
                            {
                                minValue: "25",
                                maxValue: "50"
                            },
                            {
                                minValue: "50",
                                maxValue: "100"
                            }
                        ]
                    },
                    pointers: {
                        pointer: [
                            {
                                value: this.value
                            }
                        ]
                    }
                };
            }
        },
    }
</script>